import { Container, Divider, IconButton } from "@material-ui/core";
import { Info } from "@material-ui/icons";
import {
  Box,
  Chip,
  ClickAwayListener,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import axios from "axios";
import {
  ArrayChip,
  AutoCompleteComponent,
  ButtonGroupTop,
  CurrencyDisplay,
  CustomTable,
  DateRangePicker,
  DropdownCombo,
  FormLabel,
  ModalError,
  MultipleSelectInput,
  Page,
  PrimaryButton,
  ReportErrorModalWithTable,
  ReportModalWithTable,
  SearchTextInput,
  SelectInput,
} from "components";
import { HeaderTitle } from "layouts";
import { getTotalPage } from "lib";
import { debounce } from "lodash";
import moment from "moment";
import qs from "qs";
import { useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { hardBaseUrl } from "services/urlConstant";
import { globalStyles } from "styles";
import {
  allOptionsSelected,
  arrayToCommaSeparatedString,
  createAllFilterOption,
  formatDate,
  formatPayloadDate,
  getErrors,
  handleChangeFilterAll,
  setFormatPayloadDate,
} from "utils";
import { breadcrumbData } from "../Components/SongClaimMenu";
import PopupConfirmUnclaim from "./ConfirmUnclaim";

function SongUnclaim() {
  const history = useHistory();
  const location = useLocation();
  const [selectedValue, setSelectedValue] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const handleItemClick = item => {
    setSelectedValue(item);
    handleChangeQueryParams(item?.song_id, "song_id");
    handleChangeQueryParams(item?.title_song, "song_title");
  };
  const classes = globalStyles();
  const { publisherId } = useSelector(state => state?.publisherId);
  let token = localStorage.getItem("token");
  const headers = {
    Authorization: "Bearer " + token,
  };
  const urlParams = new URLSearchParams(location.search);
  const paramsPage = urlParams?.get("page");
  const paramsSize = urlParams?.get("per_page");
  const paramsHeaderId = urlParams?.get("header_id");
  const paramsStartDate = urlParams?.get("start_date");
  const paramsEndDate = urlParams?.get("end_date");
  const paramsDSP = urlParams?.get("dsp_id");
  const paramsSongTitle = urlParams?.get("song_title");
  const paramsArtist = urlParams?.get("artist");
  const paramsIswc = urlParams?.get("iswc");
  const paramsIsrc_code = urlParams?.get("isrc_code");
  const paramsComposer = urlParams?.get("composer");
  const paramsSort = urlParams?.get("sort");

  const [loadingPage, setLoadingPage] = useState(false);
  const [loadingFilter, setLoadingFilter] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [popupConfirm, setPopupConfirm] = useState(false);
  const [itemsUnclaim, setItemsUnclaim] = useState();
  const optionType = [
    {
      id: 0,
      label: "Song References",
    },
    { id: 1, label: "Workcode" },
  ];
  const [optionDsp, setOptionDsp] = useState([]);
  const [optionProcessInfo, setOptionProcessInfo] = useState([]);
  const [processInfoParams, setProcessInfoParams] = useState({
    start_date: paramsStartDate
      ? setFormatPayloadDate(paramsStartDate)
      : moment().startOf("year"),
    end_date: paramsEndDate ? setFormatPayloadDate(paramsEndDate) : moment(),
  });
  const [selectedDsp, setSelectedDsp] = useState({
    dsp_id: 0,
    name: "None",
  });
  const [selectedType, setSelectedType] = useState({
    id: 0,
    name: "None",
  });
  const [selectedProcessInfo, setSelectedProcessInfo] = useState([]);
  const [claimInput, setClaimInput] = useState({
    workcode: "",
    publisher_share_percentage: 0,
  });
  const [existingSongCheck, setExistingSongCheck] = useState(true);
  const [queryParams, setQueryParams] = useState({
    page: Number(paramsPage) || 1,
    per_page: Number(paramsSize) || 10,
    header_id: paramsHeaderId || "",
    song_id: "",
    song_title: paramsSongTitle || "",
    artist: paramsArtist || "",
    iswc: paramsIswc || "",
    isrc_code: paramsIsrc_code || "",
    composer: paramsComposer || "",
    sort: paramsSort || "",
  });
  const [dataTable, setDataTable] = useState([]);
  const [tablePageCount, setTablePageCount] = useState(1);
  const [selectedSongClaim, setSelectedSongClaim] = useState([]);
  const [modalReportVisible, setModalReportVisible] = useState(false);
  const [modalReportErrorVisible, setModalReportErrorVisible] = useState(false);
  const [detailReport, setDetailReport] = useState({});
  const [songs, setSongs] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const pageSize = 10;
  const [open, setOpen] = useState(false);
  const isValidSearchParams = (params = queryParams) => {
    const { song_title, artist, iswc, isrc_code, composer } = params;
    const values = [song_title, artist, iswc, isrc_code, composer];

    const allEmpty = values.every(val => (val || "").trim() === "");
    const allValidLength = values.every(
      val => (val || "").trim() === "" || (val || "").trim().length >= 3
    );

    return allEmpty || allValidLength;
  };

  const allSongClaimSelected =
    dataTable?.length > 0 &&
    dataTable.every(option =>
      selectedSongClaim?.some(selected => selected?.id === option?.id)
    );

  const disabledCheckboxAll = dataTable?.length < 1;
  const handleTooltipOpen = () => {
    setOpen(true);
  };

  const handleClaimWorkcode = (type, value) => {
    setClaimInput({
      ...claimInput,
      [type]: value,
    });
  };

  const handleTooltipClose = () => {
    setOpen(false);
  };
  const handleChangeProcessInfoParams = (value, key) => {
    setProcessInfoParams(currentState => ({
      ...currentState,
      [key]: value,
    }));
    handleChangePageParams(formatPayloadDate(value), key);
  };

  const handleChangePageParams = (value, key) => {
    urlParams.set(key, value);
    history.replace({
      pathname: location.pathname,
      search: urlParams.toString(),
    });
  };

  const handleChangeQueryParams = (value, key) => {
    setQueryParams(currentState => ({
      ...currentState,
      ...(key !== "page" && { page: 1 }),
      [key]: value,
    }));
    handleChangePageParams(value, key);
    if (key !== "page") {
      handleChangePageParams(1, "page");
    }
  };

  const handleChangeFilterDSP = value => {
    setSelectedDsp(optionDsp?.find(item => item?.dsp_id === Number(value)));
    handleChangePageParams(value, "dsp_id");
    if (value !== paramsDSP) {
      handleResetFilter("filter");
    }
    if (!value) {
      setOptionProcessInfo([]);
    }
  };

  const handleChangeSelectType = e => {
    const { value } = e?.target;
    setSelectedType(optionType?.find(item => item?.id === Number(value)));
    setExistingSongCheck(value === 0 ? true : false);
    setSelectedValue();
    setQueryParams({
      ...queryParams,
      song_id: "",
      song_title: "",
      artist: "",
      iswc: "",
      isrc_code: "",
      composer: "",
    });
  };
  const handleChangeFilterProcessInfo = (event, option) => {
    const { checked } = event?.target || false;
    setSelectedProcessInfo(
      handleChangeFilterAll({
        selectedList: selectedProcessInfo,
        checked,
        option,
        key: "header_id",
        list: optionProcessInfo,
        handleChangeQueryParams,
      })
    );
  };

  const handleCheckSong = rowId => {
    setSelectedSongClaim(prev => prev.filter(row => row.id !== rowId));
  };

  const handleSelectSong = (event, option) => {
    const { checked } = event?.target || false;

    setSelectedSongClaim(prev => {
      if (checked) {
        const alreadyExist = prev.some(item => item.id === option.id);
        return alreadyExist ? prev : [...prev, option];
      } else {
        return prev.filter(item => item.id !== option.id);
      }
    });
  };

  const handleSelectAllSongClaim = event => {
    const { checked } = event?.target || false;
    setSelectedSongClaim(checked ? dataTable : []);
  };

  const handleShowReportDetail = async data => {
    setDetailReport(data);
    setModalReportVisible(true);
  };

  const handleShowReportErrorDetail = async data => {
    setDetailReport(data);
    setModalReportErrorVisible(true);
  };

  const handleCloseModalReport = () => {
    setModalReportVisible(false);
    getDataTable();
    handleResetFilter();
  };

  const handleCloseModalReportError = () => {
    setModalReportErrorVisible(false);
    getDataTable();
    handleResetFilter();
  };

  const handleResetFilter = type => {
    if (type === "filter") {
      setSelectedProcessInfo([]);
      handleChangeQueryParams("", "header_id");
    }
    setSelectedSongClaim([]);
  };

  const handleSearchChange = event => {
    setSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  const handleCloseConfirm = () => {
    setPopupConfirm(false);
    setLoadingButton(false);
  };

  const clearState = () => {
    setSelectedSongClaim([]);
    setQueryParams({
      page: Number(paramsPage) || 1,
      per_page: Number(paramsSize) || 10,
      header_id: paramsHeaderId || "",
      song_id: "",
      song_title: paramsSongTitle || "",
      artist: paramsArtist || "",
      iswc: paramsIswc || "",
      isrc_code: paramsIsrc_code || "",
      composer: paramsComposer || "",
      workcode: "",
      publisher_share_percentage: 0,
    });
    localStorage.removeItem("params_song_unclaim", { path: "/" });
  };

  const mapSongs = apiSongs =>
    apiSongs.map(song => ({
      song_id: song.song_id,
      title_song: song.title_song,
      iswc_code: song.iswc_code,
      isrc: song.isrc || [],
      composer: song.song_composer
        ?.map(sc => sc.composer?.alias_name || sc.composer?.sure_name)
        .filter(Boolean), // hilangkan null/undefined
      performers: song.performers,
    }));
  const fetchSongs = async (currentPage, searchQuery) => {
    try {
      setIsLoading(true);
      const encodedSearch = encodeURIComponent(searchQuery || ""); // encode simbol & dan spasi
      const response = await axios.get(
        `${hardBaseUrl}/songs?page=${currentPage}&size=${pageSize}&search=${encodedSearch}`,
        { headers }
      );

      const rawSongs = response.data?.data || [];
      const mapped = mapSongs(rawSongs);

      setSongs(prevSongs => {
        const filteredMapped = mapped.filter(
          newSong =>
            !prevSongs.some(existing => existing.song_id === newSong.song_id)
        );
        return [...prevSongs, ...filteredMapped];
      });

      setHasMore(rawSongs.length === pageSize);
    } catch (error) {
      console.error("Error fetching songs", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchSongs(page, searchQuery);
  }, [page, searchQuery]);

  const getOptionDSP = async () => {
    try {
      setLoadingFilter(true);
      const url = `${hardBaseUrl}/publishers/list/${publisherId}/dsps`;
      const res = await axios.get(url, { headers });
      const modifiedData = res?.data?.data?.map(item => ({
        ...item,
        id: item?.dsp_id,
        label: item?.name,
      }));
      setOptionDsp(modifiedData);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilter(false);
    }
  };
  const getProcessInfoList = async () => {
    try {
      setLoadingFilter(true);
      const res = await axios.get(
        `${hardBaseUrl}/unclaim/header/${selectedDsp?.dsp_id}`,
        {
          headers,
          params: {
            start_date: formatPayloadDate(processInfoParams?.start_date),
            end_date: formatPayloadDate(processInfoParams?.end_date),
          },
        }
      );
      const { data } = res?.data;
      const updatedList = [
        createAllFilterOption({ key: "header_id", label: "name" }),
        ...data,
      ];
      setOptionProcessInfo(updatedList);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingFilter(false);
    }
  };

  const isEncoded = str => {
    try {
      // Decode sekali
      const once = decodeURIComponent(str);
      // Decode dua kali
      const twice = decodeURIComponent(once);

      // Kalau decode sekali sama dengan aslinya → belum encoded
      if (once === str) return false;
      // Kalau decode dua kali masih berubah → berarti double encoded
      if (twice !== once) return false;
      // Sisanya dianggap encoded sekali saja
      return true;
    } catch (e) {
      return false;
    }
  };

  const queryParamsRef = useRef(queryParams);
  queryParamsRef.current = queryParams;

  const getDataTable = async (params = queryParams) => {
    if (!isValidSearchParams(params)) return;

    try {
      setLoadingPage(true);

      const encodedParams = {
        ...params,
        song_title: params.song_title
          ? isEncoded(params.song_title)
            ? params.song_title // sudah encoded → pakai langsung
            : encodeURIComponent(params.song_title) // belum encoded → encode
          : "",
      };

      const res = await axios.get(`${hardBaseUrl}/unclaim/datatable`, {
        headers,
        params: encodedParams,
        paramsSerializer: serializerParams =>
          qs.stringify(serializerParams, { encode: false }), // ⬅️ cegah double encode
      });

      const { data, meta } = res?.data;
      setDataTable(data || []);

      const pageCount = getTotalPage(meta?.total, params?.per_page);
      setTablePageCount(pageCount || 1);
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingPage(false);
    }
  };

  const debounceDataTable = useMemo(
    () =>
      debounce(() => {
        getDataTable(queryParamsRef.current);
      }, 500),
    []
  );

  const handleShowPopupConfirm = () => {
    if (existingSongCheck && selectedValue === undefined) {
      setLoadingButton(false);
      return ModalError("Song Reference can't be empty");
    }
    let modifiedSelectedSong = selectedSongClaim?.map(item => ({
      ...item,
      publisher_id: publisherId,
      dsp_name: selectedDsp.name,
    }));
    if (!existingSongCheck) {
      modifiedSelectedSong = selectedSongClaim?.map(item => {
        const composerData = [];
        item.composers?.map(val =>
          composerData.push({
            is_checked: false,
            composer_name: val,
            ownership_percentage: 0,
          })
        );
        return {
          ...item,
          publisher_id: publisherId,
          dsp_name: selectedDsp.name,
          composer_data: composerData,
          is_primary_song: false,
        };
      });
    }
    if (modifiedSelectedSong.length < 1) {
      return ModalError("Please choose song title");
    }
    setItemsUnclaim(modifiedSelectedSong);
    setPopupConfirm(true);
  };

  const postClaimSong = async composerData => {
    setLoadingButton(true);
    let payload = {};
    if (!existingSongCheck) {
      const cleanedComposerData = composerData.map(
        ({ id, composers, is_primary_song, composer_data }) => {
          const cleanedComposerDataArray = (composer_data || [])
            .filter(item => item.is_checked === true)
            .map(({ composer_name, ownership_percentage }) => ({
              composer_name,
              ownership_percentage,
            }));
          return {
            id,
            composers,
            is_primary_song,
            composer_data: cleanedComposerDataArray,
          };
        }
      );
      payload = {
        is_use_existing_song: existingSongCheck,
        start_date: moment
          .utc(processInfoParams?.start_date)
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end_date: moment
          .utc(processInfoParams?.end_date)
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),

        dsp_id: Number(selectedDsp?.dsp_id),
        song_id: 0,
        t_unclaim_detail: cleanedComposerData,
        workcode: claimInput.workcode,
        publisher_share_percentage: Number(
          claimInput.publisher_share_percentage
        ),
      };
    } else {
      payload = {
        is_use_existing_song: existingSongCheck,
        start_date: moment
          .utc(processInfoParams?.start_date)
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),
        end_date: moment
          .utc(processInfoParams?.end_date)
          .startOf("day")
          .format("YYYY-MM-DDTHH:mm:ss[Z]"),

        song_id: selectedValue.song_id,
        dsp_id: Number(selectedDsp?.dsp_id),
        t_unclaim_detail: composerData?.map(({ id }) => ({ id })) || [],
      };
    }

    try {
      const res = await axios.post(`${hardBaseUrl}/unclaim/claim`, payload, {
        headers,
      });
      if (res.status === 200) {
        setLoadingButton(false);
        setPopupConfirm(false);
        clearState();
        handleShowReportDetail(res?.data?.data);
      }
    } catch (error) {
      handleShowReportErrorDetail(error?.response?.data?.errors);
    } finally {
      setLoadingButton(false);
    }
  };

  useEffect(() => {
    let modifiedSelectedSong = selectedSongClaim?.map(item => ({
      ...item,
      publisher_id: publisherId,
      dsp_name: selectedDsp.name,
    }));
    if (!existingSongCheck) {
      modifiedSelectedSong = selectedSongClaim?.map(item => {
        const composerData = [];
        item.composers?.map(val =>
          composerData.push({
            is_checked: false,
            composer_name: val,
            ownership_percentage: 0,
          })
        );
        return {
          ...item,
          publisher_id: publisherId,
          dsp_name: selectedDsp.name,
          composer_share_percentage:
            100 - claimInput.publisher_share_percentage,
          composer_data: composerData,
          is_primary_song: false,
        };
      });
    }
    setItemsUnclaim(modifiedSelectedSong);
  }, [claimInput?.publisher_share_percentage]);

  useEffect(() => {
    const KEY = "visited_via_navigation";

    const isDirectAccess = !sessionStorage.getItem(KEY);

    if (isDirectAccess) {
      console.log("User membuka langsung halaman ini → clear cookies");
      // clearState();
    } else {
      console.log("User datang dari navigasi internal → keep cookies");
    }

    // Tandai bahwa user telah mengunjungi halaman ini lewat navigasi
    sessionStorage.setItem(KEY, "true");
  }, []);

  useEffect(() => {
    getOptionDSP();
  }, []);
  useEffect(() => {
    if (selectedDsp?.dsp_id) {
      getProcessInfoList();
    }
  }, [processInfoParams, selectedDsp]);
  useEffect(() => {
    const hasSelectedProcessInfo = selectedProcessInfo?.length > 0;
    const isSearching = Boolean(
      queryParams?.song_title ||
        queryParams?.artist ||
        queryParams?.iswc ||
        queryParams?.isrc_code ||
        queryParams?.composer
    );

    if (!hasSelectedProcessInfo) return;
    if (isSearching) {
      debounceDataTable();
      return () => {
        debounceDataTable.cancel();
      };
    } else {
      getDataTable();
    }
  }, [selectedProcessInfo, queryParams, debounceDataTable]);
  useEffect(() => {
    if (optionDsp && optionDsp.length > 0 && paramsDSP) {
      handleChangeFilterDSP(paramsDSP);
    }
  }, [optionDsp]);
  useEffect(() => {
    if (optionProcessInfo && optionProcessInfo.length > 0 && paramsHeaderId) {
      const selectedId = paramsHeaderId?.split(",")?.map(id => id.trim());
      const selected = optionProcessInfo.filter(option =>
        selectedId.includes(option.header_id.toString())
      );
      setSelectedProcessInfo(
        allOptionsSelected({
          list: optionProcessInfo,
          key: "header_id",
          selectedFilter: selected,
        })
          ? optionProcessInfo
          : selected
      );
    }
  }, [optionProcessInfo]);
  return (
    <Page className={classes?.root} title="Unclaim">
      <Container maxWidth={false}>
        <HeaderTitle title="Song Claim" breadcrumbData={breadcrumbData} />
        <ButtonGroupTop />
        <Divider className={classes?.flatDivider} />
        <Grid container spacing={2} my={2}>
          <Grid item xs={12} sm={6} md={3}>
            <FormLabel label="Date Range" />
            <Box sx={{ maxWidth: "100%" }}>
              <DateRangePicker
                width={"100%"}
                startDate={processInfoParams?.start_date}
                endDate={processInfoParams?.end_date}
                handleChangeStartDate={date =>
                  handleChangeProcessInfoParams(date, "start_date")
                }
                handleChangeEndDate={date =>
                  handleChangeProcessInfoParams(date, "end_date")
                }
                disabled={loadingPage}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormLabel label="Select DSP" />
            <Box sx={{ maxWidth: "100%" }}>
              <AutoCompleteComponent
                options={optionDsp}
                value={
                  optionDsp?.find(
                    option => option?.id === Number(selectedDsp?.dsp_id)
                  ) || null
                }
                onChange={handleChangeFilterDSP}
                size="small"
                disabled={loadingFilter || loadingPage}
                width={"100%"}
              />
            </Box>
          </Grid>
          {optionProcessInfo.length > 1 && (
            <Grid item xs={12} sm={6} md={2}>
              <FormLabel label="Process Header" />
              <Box sx={{ maxWidth: "100%" }}>
                <MultipleSelectInput
                  placeholder="Process Info"
                  value={selectedProcessInfo}
                  textValue={
                    selectedProcessInfo.length > 0 &&
                    selectedProcessInfo.some(item => item?.header_id === "all")
                      ? "All"
                      : arrayToCommaSeparatedString(
                          selectedProcessInfo,
                          "header_id"
                        )
                  }
                  options={optionProcessInfo}
                  optionKey={"header_id"}
                  onChange={handleChangeFilterProcessInfo}
                  checkBoxLabel={item =>
                    optionProcessInfo?.length
                      ? item?.header_id === "all"
                        ? "All"
                        : `${item?.header_id} : (${formatDate(
                            item?.start_date
                          )} - ${formatDate(item?.end_date)})`
                      : null
                  }
                  disabled={loadingFilter || loadingPage}
                  loading={loadingFilter}
                  width={"100%"}
                />
              </Box>
            </Grid>
          )}
          <Grid item xs={12} sm={6} md={2}>
            <FormLabel label="Select Type" />
            <Box sx={{ maxWidth: "100%" }}>
              <SelectInput
                options={optionType}
                optionKey="id"
                optionLabel="label"
                value={selectedType?.id}
                onChange={handleChangeSelectType}
                size="small"
                disabled={loadingFilter || loadingPage}
                width={"100%"}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={3}>
            <Box
              sx={{
                width: "100%",
                pointerEvents: !existingSongCheck ? "none" : "auto",
                opacity: !existingSongCheck ? 0.5 : 1,
              }}
            >
              <FormLabel label="Song Reference" />
              <Box sx={{ maxWidth: "100%" }}>
                <DropdownCombo
                  width={"100%"}
                  data={songs}
                  onChange={handleItemClick}
                  label="Song Reference"
                  placeholder="Song Reference"
                  selectedValue={selectedValue}
                  hasMore={hasMore}
                  isLoading={isLoading}
                  searchQuery={searchQuery}
                  handleSearchChange={handleSearchChange}
                  handleClearSearch={handleClearSearch}
                  onScrollToEnd={() => {
                    if (!isLoading && hasMore) setPage(prev => prev + 1);
                  }}
                  disabled={loadingPage}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container spacing={2}>
            {searchTypeList?.map(field => (
              <Grid item xs={12} sm={3} md={2} key={field.key}>
                <FormLabel label={`${field.label} Search`} />
                <Grid display={"flex"}>
                  <SearchTextInput
                    placeholder={field.label}
                    value={queryParams?.[field.key]}
                    disabled={
                      (existingSongCheck &&
                        queryParams?.song_title &&
                        queryParams?.song_id &&
                        field.key === "song_title") ||
                      loadingPage
                    }
                    onChange={event =>
                      handleChangeQueryParams(event?.target?.value, field.key)
                    }
                    width={"100%"}
                  />
                  {field.key === "isrc_code" && (
                    <ClickAwayListener
                      onClickAway={handleTooltipClose}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <div>
                        <Tooltip
                          title="Minimum Search is 3 Letters"
                          placement="top"
                          open={open}
                          disableFocusListener
                          disableHoverListener
                          disableTouchListener
                        >
                          <IconButton onClick={handleTooltipOpen}>
                            <Info />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </ClickAwayListener>
                  )}
                </Grid>
              </Grid>
            ))}
            <Grid item xs={12} md={2}>
              <Box mt={4}>
                <PrimaryButton
                  label={
                    loadingButton ? "Processing Claim ..." : "Claim This Song"
                  }
                  onClick={handleShowPopupConfirm}
                  disabled={loadingButton || loadingPage}
                  loading={loadingButton}
                  fullWidth
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        <Divider className={classes?.divider} />
        {selectedValue && (
          <Grid container spacing={2}>
            {selectedValue.performers?.length > 0 && (
              <Grid item sm={3} md={6}>
                <FormLabel label="Artist" />
                <ArrayChip
                  list={selectedValue?.performers?.map(name => ({
                    name: name.first_name,
                    className: classes?.highlightText,
                  }))}
                  max={3}
                />
              </Grid>
            )}
            {selectedValue?.iswc_code && (
              <Grid item sm={3} md={6}>
                <FormLabel label="ISWC" />
                <Chip
                  label={selectedValue.iswc_code}
                  variant="outlined"
                  sx={{ m: 0.5 }}
                  className={classes?.highlightText}
                />
              </Grid>
            )}
            {selectedValue?.composer?.length > 0 && (
              <Grid item sm={3} md={6}>
                <FormLabel label="Composers" />
                <ArrayChip
                  list={selectedValue?.composer?.map(name => ({
                    name,
                    className: classes?.highlightText,
                  }))}
                  max={5}
                />
              </Grid>
            )}
            {selectedValue?.isrc?.length > 0 && (
              <Grid item sm={3} md={6}>
                <FormLabel label="ISRC" />
                <ArrayChip
                  list={selectedValue?.isrc?.map(name => ({
                    name,
                    className: classes?.highlightText,
                  }))}
                  max={3}
                />
              </Grid>
            )}
          </Grid>
        )}
        {selectedProcessInfo.length > 0 ? (
          <CustomTable
            isLoading={loadingPage}
            columnTable={columnTable({ selectedDsp, classes })}
            data={dataTable}
            page={queryParams?.page}
            pageSize={queryParams?.per_page}
            pageCount={tablePageCount}
            sortValue={queryParams?.sort}
            onRequestSort={sortBy => {
              return handleChangeQueryParams(
                `${sortBy} ${
                  queryParams?.sort === `${sortBy} asc` ? "desc" : "asc"
                }`,
                "sort"
              );
            }}
            handleChangePage={(_, data) => {
              setSelectedSongClaim([]);
              handleChangeQueryParams(data, "page");
            }}
            handleChangePageSize={e =>
              handleChangeQueryParams(e?.target?.value, "per_page")
            }
            isHaveCheckbox={!disabledCheckboxAll}
            checkboxHeaderChecked={allSongClaimSelected}
            handleCheckboxHeader={handleSelectAllSongClaim}
            checked={item =>
              selectedSongClaim?.some(selected => selected?.id === item?.id)
            }
            handleCheckbox={handleSelectSong}
            hideLastPage
            mt={2}
          />
        ) : (
          <Typography
            fontSize={18}
            fontWeight={400}
            color="#687083"
            textAlign="center"
            my="40px"
          >
            Select Date Range and DSP to view song unclaim&apos;s data
          </Typography>
        )}
        <ReportModalWithTable
          detailReport={detailReport}
          modalVisible={modalReportVisible}
          onClose={handleCloseModalReport}
          staticMessage="Data is being processed, Please check the progress of the unclaim process in the Unclaim Monitoring."
          redirectLink="/admin/publisher/unclaim-monitoring"
          newTab
        />
        <ReportErrorModalWithTable
          detailReport={detailReport}
          modalVisible={modalReportErrorVisible}
          onClose={handleCloseModalReportError}
        />

        <PopupConfirmUnclaim
          modalVisible={popupConfirm}
          onClose={handleCloseConfirm}
          handleCheckSong={handleCheckSong}
          items={itemsUnclaim || []}
          onSubmit={postClaimSong}
          isExistingSong={existingSongCheck}
          loadingButton={loadingButton}
          claimInput={claimInput}
          handleClaimWorkcode={handleClaimWorkcode}
        />
      </Container>
    </Page>
  );
}

const searchTypeList = [
  { label: "Song Title", key: "song_title" },
  { label: "Composer", key: "composer" },
  { label: "Artist", key: "artist" },
  { label: "ISWC", key: "iswc" },
  { label: "ISRC", key: "isrc_code" },
];

const columnTable = ({ selectedDsp, classes }) => [
  {
    name: "song_title",
    title: "Song Title",
    useSort: true,
    sort_key: "song_title",
    renderText: item => <strong>{item}</strong>,
  },
  {
    name: "all",
    title: "ISRC Code",
    useSort: true,
    sort_key: "isrc_code",
    renderText: item => (
      <span className={classes.italicText}>
        <strong>{item.isrc_code}</strong>
        {item.alternate_isrc}
      </span>
    ),
  },
  {
    name: "iswc",
    title: "ISWC Code",
    useSort: true,
    sort_key: "iswc",
    renderText: item => <span className={classes.italicText}>{item}</span>,
  },
  {
    name: "composers",
    title: "Composer/Author",
    useSort: true,
    sort_key: "composer",
    renderText: item => <ArrayChip list={item} max={2} />,
  },
  {
    name: "artist",
    title: "Artist",
    useSort: true,
    sort_key: "artist",
  },
  {
    name: "number_of_streams",
    title: "Number of Stream",
    useSort: true,
    sort_key: "number_of_streams",

    renderText: item => <CurrencyDisplay value={item} />,
  },
  {
    name: "all",
    title: "DSP Name",
    renderText: () => selectedDsp?.name,
  },
  {
    name: "process_date",
    title: "Process Date",

    renderText: date => formatDate(date),
  },
  {
    name: "all",
    title: "Period Date",

    renderText: item =>
      `${formatDate(item?.start_date)} - ${formatDate(item?.end_date)}`,
  },
];
export default SongUnclaim;
